import { render, staticRenderFns } from "./office-add.vue?vue&type=template&id=e54a75c8&scoped=true&"
import script from "./office-add.vue?vue&type=script&lang=js&"
export * from "./office-add.vue?vue&type=script&lang=js&"
import style0 from "./office-add.vue?vue&type=style&index=0&id=e54a75c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54a75c8",
  null
  
)

export default component.exports